import * as c from "@yahshi/contracts";

export type InAppEnqueueInput = {
  appId: string;
  appName: string;
  userId: string;
  eventKey: string;
  occurrenceKey: string;
  category: c.NotificationCategory;
  title: string;
  titleUg?: string;
  body: string;
  bodyUg?: string;
  createdAt?: string;
};

export type DevelopmentInAppInbox = {
  enqueue(input: InAppEnqueueInput): c.NotificationMessage | null;
  setChannelEnabled(appId: string, enabled: boolean): void;
  listMessages(query?: { appId?: string; userId?: string; unreadOnly?: boolean; page?: number; pageSize?: number }): c.NotificationMessagePage;
  listDeliveries(query?: Partial<c.NotificationDeliveryQuery>): c.NotificationDeliveryPage;
  delivery(id: string, query?: { page?: number; pageSize?: number }): c.NotificationDeliveryDetail;
  userSummary(userId: string): c.NotificationUserSummary;
};

const apps = {
  app_yahshi_web: "Yahshi Web",
  app_yahshi_admin: "Yahshi Admin",
} as const;

const seed: InAppEnqueueInput[] = [
  { appId: "app_yahshi_web", appName: apps.app_yahshi_web, userId: "11111111-1111-4111-8111-111111111111", eventKey: "order.paid", occurrenceKey: "cord_demo_20260915002", category: "transactional", title: "订单支付状态已记录", titleUg: "پۇل تۆلەش ھالىتى خاتىرىلەندى", body: "订单 cord_demo_20260915002 业务状态已更新，不代表微信资金到账或退款完成。", bodyUg: "سودا ھالىتى يېڭىلاندى؛ ۋېيشىن پۇلىنىڭ كەلگەنلىكى ياكى قايتۇرۇلغانلىقىنى بىلدۈرمەيدۇ.", createdAt: "2026-09-10T11:18:01.000Z" },
  { appId: "app_yahshi_web", appName: apps.app_yahshi_web, userId: "55555555-5555-4555-8555-555555555555", eventKey: "order.paid", occurrenceKey: "cord_demo_20260915003", category: "transactional", title: "订单支付状态已记录", titleUg: "پۇل تۆلەش ھالىتى خاتىرىلەندى", body: "订单 cord_demo_20260915003 业务状态已更新，不代表微信资金到账或退款完成。", bodyUg: "سودا ھالىتى يېڭىلاندى؛ ۋېيشىن پۇلىنىڭ كەلگەنلىكى ياكى قايتۇرۇلغانلىقىنى بىلدۈرمەيدۇ.", createdAt: "2026-09-08T05:28:01.000Z" },
  { appId: "app_yahshi_admin", appName: apps.app_yahshi_admin, userId: "33333333-3333-4333-8333-333333333333", eventKey: "order.paid", occurrenceKey: "cord_demo_20260909004", category: "transactional", title: "订单支付状态已记录", titleUg: "پۇل تۆلەش ھالىتى خاتىرىلەندى", body: "订单 cord_demo_20260909004 业务状态已更新，不代表微信资金到账或退款完成。", bodyUg: "سودا ھالىتى يېڭىلاندى؛ ۋېيشىن پۇلىنىڭ كەلگەنلىكى ياكى قايتۇرۇلغانلىقىنى بىلدۈرمەيدۇ.", createdAt: "2026-09-07T08:22:01.000Z" },
  { appId: "app_yahshi_admin", appName: apps.app_yahshi_admin, userId: "33333333-3333-4333-8333-333333333333", eventKey: "order.refunded", occurrenceKey: "cord_demo_20260909004", category: "transactional", title: "订单退款状态已记录", titleUg: "پۇل قايتۇرۇش ھالىتى خاتىرىلەندى", body: "订单 cord_demo_20260909004 业务状态已更新，不代表微信资金到账或退款完成。", bodyUg: "سودا ھالىتى يېڭىلاندى؛ ۋېيشىن پۇلىنىڭ كەلگەنلىكى ياكى قايتۇرۇلغانلىقىنى بىلدۈرمەيدۇ.", createdAt: "2026-09-09T03:40:01.000Z" },
  { appId: "app_yahshi_web", appName: apps.app_yahshi_web, userId: "11111111-1111-4111-8111-111111111111", eventKey: "membership.granted", occurrenceKey: "memb_demo_20260915001", category: "transactional", title: "会员已开通", titleUg: "ئەزالىق ئېچىلدى", body: "当前应用会员已开通或续期。", bodyUg: "نۆۋەتتىكى ئەپ ئەزالىقى ئېچىلدى ياكى ئۇزارتىلدى.", createdAt: "2026-09-15T02:18:01.000Z" },
  { appId: "app_yahshi_admin", appName: apps.app_yahshi_admin, userId: "33333333-3333-4333-8333-333333333333", eventKey: "membership.canceled", occurrenceKey: "memb_demo_20260909003", category: "transactional", title: "会员已取消", titleUg: "ئەزالىق بىكار قىلىندى", body: "当前应用会员已取消。", bodyUg: "نۆۋەتتىكى ئەپ ئەزالىقى بىكار قىلىندى.", createdAt: "2026-09-09T03:40:01.000Z" },
];

function occurrence(input: InAppEnqueueInput) {
  return JSON.stringify([input.appId, input.userId, input.eventKey, input.occurrenceKey, "in_app"]);
}

export function createDevelopmentInAppInbox(): DevelopmentInAppInbox {
  const messages: c.NotificationMessage[] = [];
  const deliveries: c.NotificationDelivery[] = [];
  const seen = new Map<string, c.NotificationMessage | null>();
  const channelEnabled = new Map<string, boolean>();

  const inbox: DevelopmentInAppInbox = {
    setChannelEnabled(appId, enabled) { channelEnabled.set(appId, enabled); },
    enqueue(input) {
      const key = occurrence(input);
      const prior = seen.get(key);
      if (seen.has(key)) return prior ? { ...prior } : null;
      const at = input.createdAt ?? new Date().toISOString();
      if (channelEnabled.get(input.appId) === false) {
        seen.set(key, null);
        deliveries.unshift({ id: crypto.randomUUID(), appId: input.appId, userId: input.userId, channel: "in_app", status: "blocked", messageId: null, occurrenceKey: input.occurrenceKey, eventKey: input.eventKey, recipientMasked: "", attempts: 0, lastError: "CHANNEL_STOPPED", createdAt: at, updatedAt: at });
        return null;
      }
      const message: c.NotificationMessage = {
        id: crypto.randomUUID(),
        appId: input.appId,
        userId: input.userId,
        category: input.category,
        eventKey: input.eventKey,
        title: input.title,
        titleUg: input.titleUg ?? "",
        body: input.body,
        bodyUg: input.bodyUg ?? "",
        readAt: null,
        createdAt: at,
      };
      messages.unshift(message);
      if (!seen.has(key)) {
        seen.set(key, message);
        deliveries.unshift({
          id: crypto.randomUUID(),
          appId: input.appId,
          userId: input.userId,
          channel: "in_app",
          status: "delivered",
          messageId: message.id,
          occurrenceKey: input.occurrenceKey,
          sourceType: input.occurrenceKey.startsWith("cord_") ? "business_order" : null,
          sourceId: input.occurrenceKey.startsWith("cord_") ? input.occurrenceKey : null,
          readAt: null,
          eventKey: input.eventKey,
          recipientMasked: "",
          attempts: 1,
          lastError: null,
          createdAt: at,
          updatedAt: at,
        });
      }
      return { ...message };
    },
    listMessages(query = {}) {
      const unreadOnly = query.unreadOnly === true;
      const page = query.page ?? 1;
      const pageSize = query.pageSize ?? 20;
      const matched = messages.filter((item) => {
        if (query.appId && item.appId !== query.appId) return false;
        if (query.userId && item.userId !== query.userId) return false;
        if (unreadOnly && item.readAt) return false;
        return true;
      });
      const offset = (page - 1) * pageSize;
      return {
        items: matched.slice(offset, offset + pageSize).map((item) => ({ ...item })),
        total: matched.length,
        unread: matched.filter((item) => item.readAt === null).length,
      };
    },
    delivery(id, query = {}) {
      const delivery = deliveries.find(item => item.id === id);
      if (!delivery) throw new Error("投递记录不存在");
      const message = messages.find(item => item.id === delivery.messageId && item.appId === delivery.appId && item.userId === delivery.userId) ?? null;
      const { page, pageSize } = c.notificationPaginationSchema.parse(query);
      const attempts = delivery.attempts ? [{ id: delivery.id, attempt: 1, status: delivery.status, errorCode: delivery.lastError, occurredAt: delivery.createdAt }] : [];
      return structuredClone({ delivery, message, attempts: { items: attempts.slice((page-1)*pageSize,page*pageSize), total: attempts.length } });
    },
    listDeliveries(raw = {}) {
      const query = c.notificationDeliveryQuerySchema.parse(raw);
      const { page, pageSize } = query;
      const matched = deliveries.filter((item) => {
        if (query.appId && item.appId !== query.appId) return false;
        if (query.channel && query.channel !== "all" && item.channel !== query.channel) return false;
        if (query.status !== "all" && item.status !== query.status) return false;
        if (query.userId && item.userId !== query.userId) return false;
        if (query.eventKey && item.eventKey !== query.eventKey) return false;
        if (query.keyword && !(item.id + " " + (item.occurrenceKey ?? "")).toLowerCase().includes(query.keyword.toLowerCase())) return false;
        if (query.createdFrom && Date.parse(item.createdAt) < Date.parse(query.createdFrom)) return false;
        if (query.createdTo && Date.parse(item.createdAt) >= Date.parse(query.createdTo)) return false;
        const read = item.messageId ? item.readAt ? "read" : "unread" : "unknown";
        if (query.readStatus !== "all" && query.readStatus !== read) return false;
        return true;
      });
      const offset = (page - 1) * pageSize;
      return { items: matched.sort((a,b) => b.createdAt.localeCompare(a.createdAt) || b.id.localeCompare(a.id)).slice(offset, offset + pageSize).map((item) => ({ ...item })), total: matched.length };
    },
    userSummary(userId) {
      const page = inbox.listMessages({ userId, page: 1, pageSize: 20 });
      const deliveriesPage = {
        items: deliveries.filter((item) => item.userId === userId).slice(0, 20).map((item) => ({ ...item })),
        total: deliveries.filter((item) => item.userId === userId).length,
      };
      const appId = page.items[0]?.appId ?? deliveriesPage.items[0]?.appId ?? "app_yahshi_web";
      return {
        preference: {
          version: 1,
          appId,
          userId,
          marketingEnabled: false,
          transactionalEnabled: true,
          quietStart: null,
          quietEnd: null,
          channels: { in_app: true, wechat: false, email: false, sms: false },
          updatedAt: new Date().toISOString(),
        },
        messages: page,
        deliveries: deliveriesPage,
      };
    },
  };

  for (const item of seed) inbox.enqueue(item);
  return inbox;
}
